import Dropdown from "../common/Dropdown"
import Input from "../common/Input"
import { useMemo, useState } from "react"
import { useUser } from "../../context/useUser"
import { positions } from "../../content-options/positions/userPositions"
import UserService from "../../services/user"
import useNotyf from "../../context/useNotify"
import { useNavigate } from 'react-router-dom';

const SignUpForm = ({ modalOpen, toggleModal, toggleLogin }) => {
  const [errMsg, setErrMsg] = useState("")
  const [agreeToTerms, setAgreeToTerms] = useState(false)
  const { setUser } = useUser()
  const notyf = useNotyf()
  const navigate = useNavigate();

  const [username, setUsername] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [position, setPosition] = useState("")

  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!validateForm()) {
      return
    }
    if (isLoading) {
      return
    }
    setIsLoading(true)

    const dto = {
      username: username,
      email: email,
      password: password,
      position: position,
    }

    try {
      await UserService.createUser(dto)
      const { user } = await UserService.login({ username: dto.username, password: dto.password })
      setPassword('')
      setUser(user)
      notyf.success("Account created successfully. Welcome aboard!")
      navigate('/profile')
    } catch (err) {
      console.error(err)
      notyf.error(
        "There was a problem creating your account. Please try again."
      )
    } finally {
      toggleModal()
      setIsLoading(false)
    }
  }

  const validateForm = () => {
    if (!username || !email || !password || !confirmPassword) {
      setErrMsg("There are required fields missing.")
      return false
    }
    if (password !== confirmPassword) {
      setErrMsg("Passwords do not match")
      return false
    }
    if (!agreeToTerms) {
      setErrMsg("You must agree to the terms of service")
      return false
    }
    if (password.length < 9) {
      setErrMsg("Password must be at least 9 characters long")
      return false
    }
    return true
  }

  const handleSwitchForm = (e) => {
    e.preventDefault()
    toggleLogin()
  }

  // Dropdown
  const handleSelectPosition = (selectedOption) => {
    if (!selectedOption) {
        return
    }
    setPosition(selectedOption.value)
  };

  const positionOptions = useMemo(() => {
    return positions.map(position => ({ 
      label: position, 
      value: position 
    }));
  }, [positions]);

  return (
    <>
      <div className="modal-overlay">
        <div
          className=" modal  "
          style={{ display: `${modalOpen ? "block" : "none"}` }}
        >
          <div className="modal-dialog">
            <div className="modal-content bg-dark">
              <div className="modal-header">
                <h5 className="modal-title">Sign Up</h5>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleModal}
                >
                  Close
                </button>
              </div>
              <div className=" modal-body ">
                <form className="d-flex flex-column" onSubmit={handleSubmit}>
                  <Input
                    label="Username"
                    id="username"
                    placeholder="Enter username"
                    type="text"
                    value={username}
                    setValue={setUsername}
                  />
                  <Input
                    label="Email"
                    id="email"
                    placeholder="Enter email"
                    type="email"
                    value={email}
                    setValue={setEmail}
                  />
                  <Input
                    label="Password"
                    id="password"
                    placeholder="Enter password"
                    type="password"
                    value={password}
                    setValue={setPassword}
                  />
                  <Input
                    label="Confirm Password"
                    id="confirmPassword"
                    placeholder="Confirm password"
                    type="password"
                    value={confirmPassword}
                    setValue={setConfirmPassword}
                  />
                  <div className="form-group mt-2">
                    <label htmlFor="position">Position</label>
                    <div className="p-1 bg-light">
                      <Dropdown
                        options={positionOptions}
                        onSelect={handleSelectPosition}
                        text="Select position"
                      />
                    </div>
                  </div>
                  <div className="form-group form-check mt-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="agreeToTerms"
                      checked={agreeToTerms}
                      onChange={(e) => setAgreeToTerms(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="agreeToTerms">
                      I agree to follow VGC's terms of service
                    </label>
                  </div>
                  <p className="text-danger p-0 m-0 mt-2">{errMsg}</p>
                  <button
                    type="submit"
                    className="btn btn-primary btn-block mt-3"
                  >
                    Sign Up
                  </button>
                  <label htmlFor="confirmPassword" className="text-light mt-2">
                    Already have an account?
                  </label>{" "}
                  <button
                    className="btn btn-secondary btn-block"
                    onClick={handleSwitchForm}
                    type="button"
                  >
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignUpForm
